import { Button, Text } from '@change/ds-core-ui';

import { TypedTranslate } from '@change-corgi/core/react/i18n';

import { useErrorScreen } from './hooks/useErrorScreen';

type ErrorProps = {
	error: Error;
};

export const ErrorScreen = ({ error }: ErrorProps) => {
	const { data, actions } = useErrorScreen(error);

	return (
		<div className="flex h-[calc(100dvh-60px)] items-center md:h-auto">
			<div
				className="container mx-auto flex max-w-[620px] flex-col items-center gap-8 px-4 py-12 text-center"
				data-testid="error-screen"
			>
				<div className="flex flex-col gap-4">
					<Text as="h1" variant="heading" size="large">
						<TypedTranslate value={data.heading} />
					</Text>
					<Text as="p" variant="body">
						<TypedTranslate value={data.description} />
					</Text>
				</div>
				<Button
					as="a"
					className="mx-auto w-full md:w-auto"
					variant="primary"
					size="large"
					data-qa="primary-action-link"
					onClick={actions.handlePrimaryActionClick}
					href={data.primaryActionHref}
					target={data.primaryActionTarget}
				>
					<TypedTranslate value={data.primaryActionLabel} />
				</Button>
			</div>
		</div>
	);
};
